export const DEFAULT_DEPTH = 0 as const;
export const BASE_LEVEL = 0 as const;
export const PARENT_LEVEL = 1 as const;

export const isRoot = (depth: number): boolean => depth === DEFAULT_DEPTH;
export const isBaseLevel = (level: number): boolean => level === BASE_LEVEL;
export const isParentLevel = (level: number): boolean => level === PARENT_LEVEL;
